import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
@Component({
  selector: 'app-address-labels-mobile-no',
  templateUrl: './address-labels-mobile-no.component.html',
  styleUrls: ['./address-labels-mobile-no.component.scss'],
})
export class AddressLabelsMobileNoComponent implements OnInit {
  labelsData = [];
  tempdata = [];
  data1 = [];
  today = new Date();
  iscustomer: any;
  shortName = {
    वार्षिक: 'वा.',
    त्रैवार्षिक: 'त्रै.',
    पंचवार्षिक: 'पंच.',
    लोकनेता_गंथयात्री_वार्षिक: 'लो.गं.वा.',
    लोकमान्य_ग्रंथयात्री_वार्षिक_वर्गणी: 'लो.ग्रं.वा.व.',
    हिंदुत्व_ग्रंथयात्री: 'हिं.ग्रं.',
    हिंदुत्व_2: 'हिं.2.',
    रामसेवक_ग्रंथयात्री: 'रा.ग्रं.',
  };

  barcodeForm: FormGroup;
  constructor(
    private dialogref: MatDialogRef<AddressLabelsMobileNoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private fb: FormBuilder,
    public service: DigisubservicesService,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef) {

    this.barcodeForm = this.fb.group({
      weight: [''],
      senderId: [''],
      postalCodes: ['']
    });
  }
  weight: any
  senderId: any
  repNames = '';
  deliveryMode = '';
  firstRepName = '';
  lastRepName = '';
  district = '';
  state = '';
  taluka = '';
  country: '';
  subname: '';
  disrep: '';
  rep_names: any;
  officerep:'';

  ngOnInit(): void {
    this.labelsData = this.data['addresslabels'];
    console.log(this.data1, "data1");
    this.iscustomer = this.data['iscustomer'];
    this.deliveryMode = this.data['delivery_mode'];
    // this.chunkedData = this.chunkArray(this.data1, 4); 

    this.country = this.data['country_name'];
    this.district = this.data['district_name'];
    this.state = this.data['state_name'];
    this.taluka = this.data['taluka_name'];
    this.iscustomer = this.data['iscustomer'];
    this.subname = this.data['subname'];
    this.disrep = this.data['disrep'];
     this.officerep = this.data['officerep'];
     this.repNames = this.data['rep_names'];
      if (this.repNames.length > 0) {
      this.firstRepName =
        this.repNames[0] == 'all' ? this.repNames[1] : this.repNames[0];
      this.lastRepName = this.repNames[this.repNames.length - 1];
    }

    this.tempdata = this.uniqueid(this.labelsData, (a) => a['district']);
    this.sortDataDistrictwise();

  }
  showModal = false;

  // sortDataDistrictwise() {
  //   for (let index = 0; index < Object.keys(this.tempdata).length; index++) {
  //     let data = this.labelsData.filter(
  //       (a) => a['district'] == this.tempdata[index]['district']
  //     );

  //     // this.tempdata.push({ index: data });
  //     this.data1.push(data);
  //   }
  //   // console.log(this.data1);
  //   // console.log(this.tempdata);
  // }

  sortDataDistrictwise() {
    this.labelsData.sort((a, b) => Number(a.pincode) - Number(b.pincode));
    // this.tempdata.sort((a, b) => a.name.localeCompare(b.name, ['en', 'mr']));
    for (let index = 0; index < Object.keys(this.tempdata).length; index++) {
      let data = this.labelsData.filter(
        (a) => a['district'] == this.tempdata[index]['district']
      );

      data.map((a, index: number) => {
        a.shortname = this.shortName[a.Subscription_Type.split(' ').join('_')];
      });

      this.data1.push(data);
      console.log(this.data1);

    }




    let data = []
    this.data1.forEach(element => {
      element.forEach(data2 => {
        data.push(data2)
      });

    });
    this.data1 = data
    // this.exportToExcel(this.data1);

    // if (this.data1.length <= 4) {
    //   const requiredLength = 5;
    //   const numberOfItemsToAdd = requiredLength - this.data1.length;

    //   for (let i = 0; i < numberOfItemsToAdd; i++) {
    //     this.data1.push({
    //       shortname: '',
    //       month: '',
    //       subno: '',
    //       year: '',
    //       title: '',
    //       name: '',
    //       address: '',
    //       taluka: '',
    //       district: '',
    //       pincode: '',
    //       state: ''
    //     });
    //   }
    // }
    // this.chunkedData = this.chunkArray(this.data1, 4);
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  chunkedData: any[][] = [];
  // chunkArray(arr: any[], chunkSize: number): any[][] {
  //   const result = [];
  //   for (let i = 0; i < arr.length; i += chunkSize) {
  //     result.push(arr.slice(i, i + chunkSize));
  //   }
  //   return result;
  // }

  get displayData() {
    if (!this.data1) return [];

    let totalPerPage = 28;

    // ✅ Filter only valid records
    const filteredData = this.data1.filter(item =>
      item.name || item.address || item.mobileNumber
    );

    const data = [...filteredData];

    if (data.length > 28 || data.length == 28) {
      totalPerPage = 27
    }



    // // ✅ Fill blank slots if less than 28
    // if (data.length < totalPerPage) {
    //   const emptySlots = Array(totalPerPage - data.length).fill({
    //     short_name: '',
    //     month: '',
    //     subno: '',
    //     year: '',
    //     title: '',
    //     name: '',
    //     address: '',
    //     taluka: '',
    //     district: '',
    //     pincode: '',
    //     state: '',
    //     mobileNumber: ''
    //   });

    //   return [...data, ...emptySlots];
    // }

    return data;
  }

// Old Correct Code
// get displayData() {
//   if (!this.data1) return [];

//   const totalPerPage = 28;
//   const data = [...this.data1];

//   // 🔹 If there are fewer than 28 labels, fill remaining with empty placeholders
//   if (data.length < totalPerPage) {
//     const emptySlots = Array(totalPerPage - data.length).fill({
//       short_name: '',
//       month: '',
//       subno: '',
//       year: '',
//       title: '',
//       name: '',
//       address: '',
//       taluka: '',
//       district: '',
//       pincode: '',
//       state: '',
//       mobileNumber: ''
//     });
//     return [...data, ...emptySlots];
//   }

//   return data;
// }


}
